jQuery(document).ready(function ($) {

    // Open Mobile Menu
    $(".menu_open").on("click", function () {
        $(".mobile_menu_wrap").toggleClass("menu_show");
        $(".menu_overlay").toggle();
        $("html").toggleClass("overflow-hidden");
        $(".custom_top_bar").toggleClass("d-none");
        $(".menu_open i").toggleClass("las la-times");
        $(this).toggleClass("menu_close");
    });

    // Close Mobile Menu
    $("#search_toggle_mobile").on("click", function () {
        $(".mobile_menu_wrap").removeClass("menu_show");
        $(".menu_overlay").hide();
        $(".mobile_menu_wrap ul li ul").removeClass("show_submenu");
        $("html").removeClass("overflow-hidden");
        $(".custom_top_bar").removeClass("d-none");
        $(".menu_open i").toggleClass("las la-times");
    });

    // Add submenu classes and toggle buttons
    $(".mobile_menu_wrap ul li:has(ul)")
        .addClass("hassub")
        .append(
            '<a href="javascript:;" class="sub_menu_open"><i class="fa fa-angle-right"></i></a>'
        );

    // Add back button to submenus
    $(".mobile_menu_wrap ul li ul").append(
        '<li class="back_to_mainmenu"><a href="javascript:;"><i class="fa fa-angle-left"></i> Back</a></li>'
    );

    // Identify parent menu items without valid links
    $("li.hassub a[href='#'], li.hassub a[href='javascript:;'], li.hassub a[href='javascript:void(0);']")
        .addClass("no_link");

    // Open submenu when parent item is clicked
    $(".mobile_menu_wrap").on("click", "ul li a.no_link", function (e) {
        e.preventDefault();
        $(this).next("ul").addClass("show_submenu");
    });

    // Open submenu via arrow icon
    $(".mobile_menu_wrap").on("click", ".sub_menu_open", function (e) {
        e.preventDefault();
        $(this).siblings("ul").addClass("show_submenu");
    });

    // Back button
    $(".mobile_menu_wrap").on("click", ".back_to_mainmenu", function () {
        $(this).parent("ul").removeClass("show_submenu");
    });

});